import { useCallback } from 'react'

import { useAppDispatch } from '@/store'
import { unwrapResult } from '@reduxjs/toolkit'

import { validateEmail } from '@/features/domain/generic/actions'

export const useValidateEmail = () => {
  const dispatch = useAppDispatch()

  const validationFunction = useCallback<(email: string) => Promise<boolean>>(
    async (email: string) => {
      const thunkResult = await dispatch(validateEmail([email]))

      if (validateEmail.fulfilled.match(thunkResult)) {
        const valid = unwrapResult(thunkResult)[email]

        return valid
      }

      throw new Error(thunkResult.payload?.message ?? 'Email validation error')
    },
    [dispatch],
  )

  return validationFunction
}
